import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { Typography } from '@material-ui/core';
import { ErrorsParametros } from './ErrorsParametros/ErrorsParametros';
import { INITIAL_FILTER_STATE, INITIAL_SORT_STATE } from './ErrorsTableConstants';
import { useAuth } from '../../../../auth/authProvider';
import request from '../../../../services/network/request';
import ErrorsParametrosTable from './ErrorsParametros/ErrorsParametrosTable';

const CommunityErrors = () => {
  const { token } = useAuth();
  const [tableData, setTableData] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const [sorts, setSorts] = useState(INITIAL_SORT_STATE);
  const [selectedFilter, setSelectedFilter] = useState(undefined);

  const parseValues = obj => {
    const values = Object.entries(obj).map(item => {
      return item[1] ? `${item[0]}:${item[1]}` : '';
    });
    return values.filter(term => term !== '').join(',');
  };

  const { isFetching: isLoading, refetch } = useQuery(
    ['fetch-errors-bs', currentPage, rowsPerPage, filters, sorts],
    () => {
      const params = { sort: parseValues(sorts), page: currentPage, take: rowsPerPage, filters: parseValues(filters) };
      return request.get('backstage/comunidade/errors', { token, params });
    },
    {
      onSuccess: ({ data, pagination }) => {
        setTableData(data);
        setTotal(pagination.totalRecords);
        setCurrentPage(pagination.currentPage);
      },
    },
  );

  const handleChangePage = (_, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  const changeFilters = filter => {
    setCurrentPage(1);
    setFilters(filter);
  };

  return (
    <>
      <ErrorsParametros
        filters={filters}
        setFilters={changeFilters}
        hasFastFilterSelected={!!selectedFilter}
        setSelectedFilter={setSelectedFilter}
      />

      {!isLoading && tableData.length > 0 && (
        <ErrorsParametrosTable
          data={tableData}
          setErrors={setTableData}
          setSorts={setSorts}
          sorts={sorts}
          total={total}
          rowsPerPage={rowsPerPage}
          currentPage={currentPage}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          refetch={refetch}
        />
      )}

      {!isLoading && tableData.length === 0 && <Typography>Ops. Não encontramos nada.</Typography>}
    </>
  );
};

export { CommunityErrors };
